<div class="new-template">
  <risk-card [newCard]="true">
    <div card-header class="card-header">
      <div class="header-content">
        <div class="header-top">
          <div class="header-left">
            <div class="header-title">
              <div class="header-year" data-cy="autoVehicleYear">{{ vehicle.year }}</div>
              <div class="header-name" data-cy="autoVehicleMakeModel">
                {{ vehicle.make }} {{ vehicle.model }}
              </div>
            </div>
          </div>

          <div class="pilet">
            <div class="pilet-text icon-complete">Active</div>
          </div>
        </div>
        <div class="button">
          @if (showMobileViewGetInsuranceCardButton$) {
            <button ds-button (click)="getInsuranceCard()" data-cy="autoGetInsuranceCard">
              Get Insurance Card
            </button>
          }
        </div>
      </div>
    </div>
    <div card-body class="card-body">
      <div class="grid-container">
        <!-- Row 1 -->
        <div class="row">
          <div class="grid-cell">
            <div class="label" data-cy="policyNumTitle">Policy Number</div>
            <div class="value" data-cy="autoPolicyNumber">{{ policy | prettyPolicyNum }}</div>
          </div>
          <div class="column grid-cell">
            <div class="canceldate-value">
              <div class="label" data-cy="effectiveDatesTitle">Effective Dates</div>
              @if (policy.cancelDate) {
                <div class="pilet">
                  <div class="pilet-text">Updated</div>
                </div>
              }
            </div>
            @if (!policy.cancelDate) {
              <div class="value" data-cy="autoPolicyStartEndDate">
                {{ policy.periodStartDate | date: 'MM/dd/yyyy' }} -
                {{ policy.periodEndDate | date: 'MM/dd/yyyy' }}
              </div>
            }
            @if (policy.cancelDate) {
              <div class="value" data-cy="autoPolicyStartEndDate">
                {{ policy.periodStartDate | date: 'MM/dd/yyyy' }} -
                {{ policy.cancelDate | date: 'MM/dd/yyyy' }}
              </div>
            }
          </div>
        </div>

        <!-- Row 2 -->
        <div class="row">
          @if (coverages.length) {
            <div class="grid-cell">
              <!-- ADVANCED POLICY -->
              <div class="label" data-cy="vehicleDeductiblesTitle">Vehicle Deductibles</div>
              <div class="deductible">
                @for (coverage of coverages; track coverage) {
                  <div>
                    <auto-coverage
                      [coverage]="coverage"
                      [sourceSystem]="policy.sourceSystem"
                    ></auto-coverage>
                  </div>
                }
              </div>
              @if (additionalCoverages.length) {
                <div>
                  <div class="label" data-cy="additionalCoveragesTitle">Additional Coverages</div>
                  <div class="deductible">
                    @for (coverage of additionalCoverages; track coverage) {
                      <div class="pad-top-5" data-cy="autoCoverageName">
                        {{ coverage.coverageName }}
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
          @if (additionalCoverages.length && policy.sourceSystem === 1) {
            <div class="grid-cell">
              <!-- CLASSIC POLICY-->
              <div class="label" data-cy="classicAdditionalCoveragesTitle">
                Additional Coverages
              </div>
              <div class="deductible">
                @for (coverage of additionalCoverages; track coverage) {
                  <div>
                    <auto-coverage
                      [coverage]="coverage"
                      [sourceSystem]="policy.sourceSystem"
                    ></auto-coverage>
                  </div>
                }
              </div>
            </div>
          }
          <div class="grid-cell">
            <div class="label" data-cy="autoVehicleVINTitle">Vehicle VIN</div>
            <div class="value flex" data-cy="autoVehicleVINNumber">
              {{ vehicle.vinSerialNumber }}
              @if (this.requestChangeNewTemplate && eligibleForVinChange) {
                <div class="pad-horizontal-10">
                  <a
                    [routerLink]="['/policies/changerequest']"
                    [state]="vinChangeState"
                    class="flex items-center justify-center no-decoration"
                    >Edit <i class="icon-chevron-right-thick pad-left-4"></i
                  ></a>
                </div>
              }
            </div>
          </div>
        </div>

        <!-- Row 3 -->
        <div class="row">
          <div class="grid-cell full-width">
            <div class="label" data-cy="autoGarageAddressTitle">Garaged Address</div>
            <div class="value flex" data-cy="autoGarageLocationAddress">
              @if (vehicle.garageLocationAddress?.addressLine1) {
                <div>{{ vehicle.garageLocationAddress | address }}</div>
              } @else {
                <div>{{ policy.policyAddress | address }}</div>
              }
              @if (!isConnectPartner && requestChangeNewTemplate) {
                <div class="pad-horizontal-10">
                  <a
                    [routerLink]="['/policies/changerequest']"
                    [state]="addressChangeState"
                    class="flex items-center justify-center no-decoration"
                    >Edit <i class="icon-chevron-right-thick pad-left-4"></i
                  ></a>
                </div>
              }
            </div>
          </div>
          @if (thirdPartyInterest.length > 0) {
            <div class="grid-cell">
              <div class="label" data-cy="autoThirdPartyInterestTitle">Third Party Interest</div>
              <div class="value">
                @for (thirdParty of thirdPartyInterest; track thirdParty) {
                  <div data-cy="autoThirdPartyName">
                    {{ thirdParty.name }}
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
      <div class="image-container">
        <img src="/assets/images/Risk_info_card_foodle.svg" />
      </div>
    </div>
    <div
      [ngClass]="isConnectPartner && !isSmallScreen ? 'partner-card-footer' : 'card-footer'"
      card-footer
    >
      <a data-cy="get-documents-link" (click)="onClick()">
        <span
          class="icon"
          [ngClass]="{ 'icon-documents': !isSmallScreen, 'icon-file-claim': isSmallScreen }"
        ></span>
        <span>{{ isSmallScreen ? 'File a Claim' : 'Get Documents' }}</span>
      </a>
      @if (!isConnectPartner) {
        <a data-cy="request-policy-change-link" (click)="requestPolicyChange()">
          <span class="icon-refresh-reset"></span>
          <span data-cy="requestPolicyUpdateTitle">Request a Policy Update</span>
        </a>
      }
      <a data-cy="add-replace-vehicle-link" (click)="addReplaceVehicle()">
        <span class="icon-plus-thick"></span>
        <span data-cy="addReplaceVehicleTitle">{{
          isConnectPartner ? 'Add Vehicle' : 'Add/Replace Vehicle'
        }}</span>
      </a>
    </div>
  </risk-card>
</div>
